export class AppSettings {
  public static AppVersion = '3.0.5_QA_Build_20220426';

  static devEnv = 'https://onlineapp-dev.azurewebsites.net/api';
  static qaEnv = 'https://onlineapp-dev.azurewebsites.net/api';
  static prodEnv = 'http://onlineapp-prod.azurewebsites.net/api';
  static localEnv = 'http://localhost:8001/api';

  private static apiHost = process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'qa' ? "/api" : AppSettings.localEnv;

  public static get blobsStorage() {
    if (process.env.NODE_ENV == 'production')
      return 'https://pyndexprod.blob.core.windows.net/images';
    else
      return 'https://pyndexdev.blob.core.windows.net/images';
  }

  public static get devEnvAzureCanonicalAppName() {
    if (process.env.NODE_ENV == 'production')
      return 'onlineapp-prod'
    else
      return 'onlineapp-dev';
  }

  // static get azureFunctionDomain(){
  //   if(process.env.NODE_ENV == 'production')
  //     return 'https://pyndex-fn-prod.azurewebsites.net/api'
  //   if(process.env.NODE_ENV == 'qa')
  //     return 'https://pyndex-fn-qa.azurewebsites.net/api'
  //   else
  //     return 'http://localhost:7071/api'
  // }

  public static onlineAppLogoPath:string=`${AppSettings.blobsStorage}/wr_logo.png`

  public static endpoints = {
    users: {
      login: `${AppSettings.apiHost}/auth/login`,
      changePassword: `${AppSettings.apiHost}/auth/change-password`,
      logout: `${AppSettings.apiHost}/auth/logout`,
      register: `${AppSettings.apiHost}/auth/register`,
      userInfo: `${AppSettings.apiHost}/auth/user-info`,
      requestForgotPassword: `${AppSettings.apiHost}/auth/forgot-password`,
      forgotPasswordValidateCode: `${AppSettings.apiHost}/auth/forgot-password/validate-code/{code}`,
      forgotPasswordResetPassword: `${AppSettings.apiHost}/auth/forgot-password/reset-password`,
      launch: `${AppSettings.apiHost}/auth/launch`
    },
    enrollees: {
      configuration: `${AppSettings.apiHost}/enrollment/enrollee-stages-configuration`,
      dropdwonLookupValues: `${AppSettings.apiHost}/enrollment/field-lookup-options`,
      stagesLookup: `${AppSettings.apiHost}/enrollment/online-app-stages`,
      saveStage: `${AppSettings.apiHost}/enrollment/save-stage`,
      saveFlag: `${AppSettings.apiHost}/enrollment/save-ack-flag`,
      schools: `${AppSettings.apiHost}/enrollment/schools/{name}`,
      checkReferral: `${AppSettings.apiHost}/enrollment/check-referral/{code}`,
      uploadDocument: `${AppSettings.apiHost}/enrollment/youth-document`,
      submitApplication: `${AppSettings.apiHost}/enrollment/submit-application`,
      documentTypes: `${AppSettings.apiHost}/enrollment/document-types`,
      documentRequest: `${AppSettings.apiHost}/enrollment/enrollment-documents/{isProvider}`,
      studentDocumentUpload: `${AppSettings.apiHost}/enrollment/student-upload`,
      // enrollmentUpdateDocReq: `${AppSettings.azureFunctionDomain}/PyndexManualDocRequestHttpTrigger?applicantId={applicantId}&{funcCode}`,
      paymentMethodsLookupValues: `${AppSettings.apiHost}/enrollment/payment-lookup-options`,
      bankList: `${AppSettings.apiHost}/enrollment/student-payroll-bankList/{bankName}`,
      enrolleeAddress: `${AppSettings.apiHost}/enrollment/enrollee-address/{enrolleeId}`,
      studentPaymentMethod: `${AppSettings.apiHost}/enrollment/student-payment-method`,
      getStudentPayrollMethod: `${AppSettings.apiHost}/enrollment/student-payroll-request/{enrolleeId}`,
      addPaymentMethod: `${AppSettings.apiHost}/enrollment/student-payroll`
    },
    system: {
      contract: `${AppSettings.apiHost}/system/contract/{id}`,
      programs: `${AppSettings.apiHost}/system/enrollee-programs`,
      statements: `${AppSettings.apiHost}/system/program-statements/{progAlias}`,
      getActiveProviders: `${AppSettings.apiHost}/system/get-active-providers/{progAlias}`,
      sourceDate: `${AppSettings.apiHost}/system/enrollee-programs/{id}`
    }
  }

  public static formatUrl = (url: string, ...args: any[]): string => {
    let regex = /\{{1}\w*\}{1}/g,
      matches = url.match(regex);
    matches.forEach((m, index) => {
      url = url.replace(m, args[index]);
    })
    return url;
  }

  public static EMPTY_REQUEST_OPTIONS: any = {
    responseType: 'text',
  };

  // public static EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])[^\s]?)*$/i;

}


// WEBPACK FOOTER //
// ./src/app/shared/app-settings.ts